import { Component } from '@angular/core';

@Component({
  selector: 'app-meter-create',
  template: ``,
  styleUrls: []
})
export class MeterCreateComponent {

}
